import Layout from '../../layout/default';
import { useEffect, useState } from "react";
import { Row, Col, Button, Modal } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import RealtimeStatus from './RealtimeStatus';
import JobsheetDetail from './JobsheetDetail';
import { Navigate } from "react-router-dom";
import Icon from '../Icon/Icon';
import RefreshRealTimeNotifications from '../NotificationHub/RefreshRealTimeNotifications';
import CheckStaffAvailablity from './CheckStaffAvailablity';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = "HMCareTask/getrealtimedatav2/?fromdate=" + new Date().toISOString();

const TodaysVisitsV2 = () => {

  const api = useApiClient();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewModalselectedID, setPreviewModalselectedID] = useState(null);
  const [RefreshData, setRefresh] = useState(0);

  
  const ApiGetData = async (URL) => {
   
    try {
      const Response = await api.get(URL);
      setData(Response.data);
      //console.log(Response.data)
    } catch (error) {
      setError(error);
    }
  };


  function AssignAgentSelect(TaskID, client) {
    
    //const x = "" + client.id;
    //alert(x + ' == ' + TaskID);
  
    //const sURL = SiteConfig.API_BASE_URL + "HMCareTask/staff/assign/";
    const sURL = "HMCareTask/staff/assign/";
    
    const jsonData = {
      taskID: TaskID,
      agentID: client.id,
      type: "add"
    }

    const doAssignSelect = async () => {
      try {
        const response = await api.post(sURL,jsonData);
        setRefresh(!RefreshData);
      } catch (err) {
        setError(err);
      }
    };
    doAssignSelect();
   
  }

  function closePreviewModal() {
    setPreviewModal(false);
  }

  const JobDetailClick = (taskID) => {
    setPreviewModalselectedID(taskID);
    setPreviewModal(true);
  };

// Reload data by re-triggering API call
const reloadData = () => {
    ApiGetData(baseURL);
  };


  useEffect(() => {
    ApiGetData(baseURL);
  }, [RefreshData]);

  if (error) {
    if (error.message.includes("status code 401")) {
      return <Navigate to="/auths/auth-login" />;
    } else {
      return `Error: ${error.message}`;
    }
  }

  if (!data) {
    return (
      <Layout title="Staff" content="container">
        <Spinner animation="border" variant="primary" />
      </Layout>
    );
  }

  return (
    <>

<RefreshRealTimeNotifications setRefresh={setRefresh} />

      <Layout title="RealTime Visits" content="container" style={{ maxWidth: "95%" }}>
        <Row className="g-gs">
          <Col className="h3">
            Date: <span>{new Date().toLocaleDateString(undefined, {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}</span>{" "}
            {/* Reload Link */}
            <span onClick={reloadData} style={{ fontSize: "0.85rem", textDecoration: "underline", color: "#007bff", cursor: "pointer" }}>
            <Icon name="reload-alt"></Icon> Reload
            </span>
          </Col>
        </Row>
        <br />

        {/* Grid View */}
        <Row className="g-gs">
          {data.map((Custitem) => (
            <Col sm={12} md={6} lg={4} key={Custitem.customerID}>
              <div className="p-3 border rounded mb-3" style={{ backgroundColor: "#fff9fa" }}>
                {/* Highlighted Client Name */}
                <h5 style={{ fontWeight: "bold", fontSize: "1.1rem", color: "#333" }}>{Custitem.clientname}</h5>
                {Custitem.tasklist.map((item) => {
                  // Determine background color and text decoration based on task status
                  let taskStyle = {};
                  if (item.status === "Delay") {
                    taskStyle.backgroundColor = "#FFF4E6"; // Light orange
                  } else if (item.status === "Ready") {
                    taskStyle.backgroundColor = "#E6F7FF"; // Light blue
                  } else if (item.status === "Completed") {
                    taskStyle.textDecoration = "line-through"; // Strike off completed tasks
                  }

                  return (
                    <div key={item.taskid} className="border rounded p-2 mb-2" style={{ ...taskStyle }}>
                      <div className="small">
                        {/* Task Details */}
                        <strong onClick={() => JobDetailClick(item.taskid)} style={{ cursor: "pointer", textDecoration: "underline" }}>
                          {item.start_time}
                        </strong>{" "}
                        - {item.no_of_hours.toFixed(1)} Hour(s) - ({item.assignedAgent})
                        {" - "}{" "}
                        <RealtimeStatus status={item.status} />  
                        {item.status == "No staff" && 
                        <CheckStaffAvailablity TaskID={item.taskid} SelectClick={AssignAgentSelect}/>                        
                      }                      
                      </div>
                    </div>
                  );
                })}
              </div>
            </Col>
          ))}
        </Row>

        {/* Modal for Task Details */}
        <Modal show={previewModal} onHide={closePreviewModal} size="xl" backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title className="event-title" as="h4">JobID #{previewModalselectedID}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <JobsheetDetail taskid={previewModalselectedID} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={closePreviewModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Layout>
    </>
  );
};

export default TodaysVisitsV2;
